import { Suspense, lazy } from "react";
import { HashRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@ucl/shared-component-foundations/themeProvider";
import { ThemeName, Mode } from "@ucl/shared-component-foundations/themes";
import Loader from "@/components/ui/loader";
import GlobalStyle from "./GlobalStyledComponents";

const AnimatedRoutes = lazy(() => import("./components/ui/animated-routes"));

const App = () => {
  return (
    <ThemeProvider
      themeName={ThemeName.FORD_CREDIT}
      mode={Mode.LIGHT_MODE}
      productTeamName="fcebank"
    >
      <Router>
        <GlobalStyle />
        <Suspense fallback={<Loader />}>
          <AnimatedRoutes />
        </Suspense>
      </Router>
    </ThemeProvider>
  );
};

export default App;
